export * from './HealthCounts';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/healthCounts/index.ts